import React from 'react';
import ElementInvoice from './ElementInvoice';

 const ListInvoice = ({data,  invoiceChecks, setInvoiceChecks }) => {
    

    const [receipts,setReceipts] = React.useState([]);



    React.useEffect(() => {
        FilterReceiptData();   
    },[])
    

    const FilterReceiptData = () => {
        for (let i = 0; i < data.length; i++) {
            data[i].servicio_nombre = data[i].servicios.servicios[0].servicios;
        }
        setReceipts(data);
    }

    return (
        <>
        {receipts.map((item, index) => {
            return (<ElementInvoice 
                        key={index}
                        item={item} 
                        index={index} 
                        
                        invoiceChecks={invoiceChecks} 
                        setInvoiceChecks={setInvoiceChecks}
                    />)
        })}
    </>)
 } 


 export default React.memo(ListInvoice);